import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { ApiInstance } from "utils/Api";

type CustomerWaitingPayload = {
  appointment_id: number;
  customer_waiting: boolean;
};

export const useCustomerWaitingHandleMutation = ({ appointment_id, customer_waiting }: CustomerWaitingPayload) =>
  useTypedMutation<void, void>({
    mutationFn: async () => {
      await ApiInstance.post("/appointments/set_customer_waiting", { appointment_id, customer_waiting });
    },
    onSuccess: () => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (appointment) typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, customer_waiting });

      const appointments = typedQueryClient.getQueryData(AppointmentsQueryKeys.list);
      if (!appointments?.length) return;

      const appointmentIdx = appointments.findIndex(app => app.id === appointment_id);
      if (appointmentIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentsQueryKeys.list, appointments.with(appointmentIdx, { ...appointments[appointmentIdx], customer_waiting }));
    }
  });
